module.exports = __webpack_public_path__ + "img/germany-male.e7d17637.png";